module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_9006.1b09c1a3.png";